<div class="desktop hide-lg">
  <!-- Client -->
  <div class="dropdown header-element" *ngIf="context.customerCode as selectedCustomerCode">
    <button class="tile tile-centered btn btn-link" title="{{ this.fullContext.customer?.businessName }}"
            [ngClass]="{'dropdown-toggle': (availableCustomers?.length > 0), 'disabled-dropdown': (availableCustomers?.length === 0)}">
      <i class="fa fa-user centered"></i>
      <span class="tile-subtitle">{{ this.fullContext.customer?.businessName }}</span>
    </button>
    <ul class="menu">
      <li *ngFor="let customer of availableCustomers" class="menu-item" (mousedown)="onCustomerSelected(customer.code)">
        <a *ngIf="!customer.inactive">
          {{ customer.businessName }}
        </a>
      </li>
    </ul>
  </div>

  <!-- Livraison -->
  <div class="dropdown header-element" *ngIf="context.customerCode as selectedCustomerCode" >
    <button matTooltipPosition="right" [matTooltip]="this.adresseLivraison"
     class="tile tile-centered btn btn-link disabled-dropdown"
     title="{{ this.fullContext.order?.deliveryAddress.zipCode }} {{ this.fullContext.order?.deliveryAddress.city }}">
      <i class="fa fa-store centered"></i>
      <span class="tile-subtitle" *ngIf="this.fullContext.order">{{ this.fullContext.order?.deliveryAddress.zipCode }} {{ this.fullContext.order?.deliveryAddress.city }}</span>
      <span class="tile-subtitle text-gray" *ngIf="!this.fullContext.order">{{ 'Aucune' }}</span>
    </button>
  </div>

  <!-- Commande en cours -->
  <div class="dropdown header-element" *ngIf="context.customerCode as selectedCustomerCode">
    <button class="tile tile-centered btn btn-link dropdown-toggle" title="{{ this.fullContext.order?.code }}" (mousedown)="onOrderSelectorOpen()">
      <i class="fa fa-receipt centered"></i>
      <span class="tile-subtitle" *ngIf="this.fullContext.order">{{ this.fullContext.order?.code }}</span>
      <span class="tile-subtitle text-gray" *ngIf="!this.fullContext.order">{{ 'Aucune' }}</span>
    </button>
    <ul class="menu block">
      <li class="menu-item text-center" *ngIf="loadingOrder">
        <i class="fa fa-circle-notch fa-spin"></i>
      </li>
      <ng-container *ngIf="!loadingOrder">
        <li *ngFor="let order of availableOrders" class="menu-item" (mousedown)="onOrderSelected(order.code)">
          <a>
            {{ order.code }}
            <span class="text-gray mx-2">
              {{ order.date | stringToDate:'dd/MM/yyyy' }}
            </span>
          </a>
        </li>
      </ng-container>
      <div class="divider"></div>
      <li class="menu-item" (mousedown)="onNewOrder()">
        <a>
          <i class="fa fa-plus"></i> {{ 'order.newOrder' | translate }}
        </a>
      </li>
    </ul>
  </div>

  <div class="context-info" *ngIf="usingDetailledPanel">
    <button (click)="sendTriggerTabs()">sendTriggerTabs</button>
    <div class="context">
      <div>
        Context
      </div>
      <div>
        Company: {{context.companyCode || 'NO_COMPANY' }} / Customer: {{context.customerCode || 'NO_CUSTOMER' }} / Order: {{context.orderCode || 'NO_ORDER' }}
      </div>
    </div>
    <div class="full-context">
      <div>
        Full Context
      </div>
      <div>
        Company: {{fullContext.company?.label || 'NO_COMPANY' }} / Customer: {{fullContext.customer?.businessName || 'NO_CUSTOMER' }} / Order: {{fullContext.order?.code || 'NO_ORDER' }}
      </div>
    </div>
    <div class="context">
        <div>
          User
        </div>
        <div>
          ContactCode : {{ context.contactCode || 'NO_CONTACT' }} / Prix: {{ 'product.prices.'+activePriceListType+'Short' | translate }}
        </div>
      </div>
    </div>
</div>

<div class="mobile show-lg">
  <div class="context-banner">
    <div class="deactivated-banner" *ngIf="(validityRate && validityRate < 0) || (fullContext.order && fullContext.order.status === orderStatus.INACTIVE)">
      <span>
        {{ 'order.deactivatedMessage' | translate }}
      </span>
      <button (click)="reactivateOrderEmitter.emit()" class="btn btn-primary btn-sm">{{ 'buttons.reactivateOrderShort' | translate }}</button>
    </div>
    <div class="content">
      <section [ngClass]="{'disabled-select': (availableCompanies?.length === 0)}" *ngIf="context.companyCode as selectedCompanyCode">
        <label for="context-company-select"><i class="fa fa-fw fa-shopping-bag"></i>{{ 'company.label' | translate }}<i class="arrow fa fa-angle-up"></i></label>
        <select id="context-company-select" name="context-company" value="{{ this.fullContext.company?.code }}" [disabled]="availableCompanies?.length === 0" (change)="onCompanySelected($event.target.value)">
          <option *ngIf="this.fullContext.company" selected>{{ this.fullContext.company?.label }}</option>
          <option *ngIf="!this.fullContext.company" hidden disabled selected value>{{ 'header.none' | translate }}</option>
          <option *ngFor="let company of availableCompanies" value="{{ company.code }}">{{ company.label }}</option>
        </select>
      </section>
      <section [ngClass]="{'disabled-select': (availableCustomers?.length === 0)}" *ngIf="context.customerCode as selectedCustomerCode">
        <label for="context-customer-select"><i class="fa fa-fw fa-store"></i>{{ 'customer.label' | translate }}<i class="arrow fa fa-angle-up"></i></label>
        <select id="context-customer-select" name="context-customer" [disabled]="availableCustomers?.length === 0" (change)="onCustomerSelected($event.target.value)">
          <option *ngIf="selectedCustomerCode" value="{{ selectedCustomerCode }}" selected>{{ this.fullContext.customer?.businessName }}</option>
          <option *ngIf="!this.fullContext.customer" hidden disabled selected value>{{ 'header.none' | translate }}</option>
          <option *ngFor="let customer of availableCustomers" value="{{ customer.code }}">{{ customer.businessName }}</option>
        </select>
      </section>
      <section class="order" (click)="displayOrderSelector()" [ngClass]="{'time-displayed': validityRate && validityRate >= 0}" *ngIf="context.customerCode as selectedCustomerCode">
        <label for="context-order-select"><i class="fa fa-fw fa-receipt"></i>{{ 'order.label' | translate }}<i class="arrow fa fa-angle-up"></i></label>
        <app-remaining-time-order *ngIf="validityRate && validityRate >= 0" [remainingTime]="remainingTime" [validityRate]="validityRate" [mobile]="true"></app-remaining-time-order>
        <div class="value">{{ this.fullContext.order?.code || ('header.none' | translate) }}</div>
      </section>
    </div>
  </div>
</div>
